import { createRoot } from "react-dom/client"
import "./main.css"
import initI18n from "./i18n"
import App from "./app"

initI18n()

const element = document.getElementById("root")

if (element) {
  const root = createRoot(element)
  root.render(
    <App />
  )
}
